/****************************************************
 * Module Name:  addExchangerateModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import ExchangerateProxy from "../../utility/proxy/manager/exchangerateProxy";
import Utility from "../../utility/utility";
import Constants from "../../utility/constants";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import CircularProgress from "@mui/material/CircularProgress";
import "bootstrap/dist/css/bootstrap.min.css";
import { Box, Button, TextField } from "@mui/material";
import CommonSnackbar from "../common/commonSnackBar";
import { LoadingButton } from "@mui/lab";
import logo from '../../images/pansuriya.jpg'
import dayjs from "dayjs";
import SaveIcon from '@mui/icons-material/Save';

export default class AddExchangerateModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      newexchangedate: this.props.editOperation
        ? this.props.sourceData.exchangedate
        : new Date(),
      newrate: this.props.editOperation ? this.props.sourceData.rate : "",
      newdescription: this.props.editOperation
        ? this.props.sourceData.description
        : "",

      showError: false,

      validateExchangedatePresentSpinner: this.props.editOperation
        ? false
        : true,
      showValidationMessage: false,
      exchangedateAvailable: true,

      rateValidationError: "",
    };
    if (!this.props.editOperation) {
      this.validateExchangedatePresent(new Date(), false);
    }
  }

  handleSave = () => {
    let data = {
      id: this.props.editOperation ? this.props.sourceData.id : undefined,
      exchangedate: Utility.ConvertLocalTimeToUtc(dayjs(this.state.newexchangedate).format("YYYY-MM-DD") + "00:00:00.000"),
      rate: parseFloat(this.state.newrate).toFixed(2),
      description: this.state.newdescription,
    };

    if (this.props.handleSave) {
      if (this.props.handleValidation) {
        if (this.props.handleValidation(data)) this.props.handleSave(data);
        else
          this.setState({
            showError: true,
          });
      } else this.props.handleSave(data);
    }
  };

  closeErrorDialog = () => {
    this.setState({
      showError: false,
    });
  };

  validateExchangedatePresent = (exchangedateEntered, shouldSet) => {
    if (!exchangedateEntered) return;

    shouldSet &&
      this.setState({
        validateExchangedatePresentSpinner: true,
      });

    ExchangerateProxy.CheckExchangedateAvailable(
      Utility.ConvertLocalTimeToUtc(exchangedateEntered).slice(0, 11) +
      "00:00:00.000Z",
      (response) => {
        //if we got response that means exchange date is present at backend
        if (response) {
          //Exchangedate already present
          this.setState({
            validateExchangedatePresentSpinner: false,
            showValidationMessage: true,
            exchangedateAvailable: false,
          });
        } else {
          //Exchangedate not available, so can be used
          this.setState({
            validateExchangedatePresentSpinner: false,
            showValidationMessage: true,
            exchangedateAvailable: true,
          });
        }
      }
    );
  };

  buttonDisable = () => {
    if (this.props.editOperation && this.state.newrate.length === 0)
      return true;

    if (!this.props.editOperation)
      return (
        !this.state.showValidationMessage ||
        !this.state.exchangedateAvailable ||
        this.state.newrate.length === 0 ||
        this.state.rateValidationError.length > 0
      );

    return false;
  };

  render() {
    return (
      <Box>
        <CommonSnackbar
          show={this.state.showError}
          message={
            <Box>
              Add exchange rate validation Failed
              <br /> Please enter complete data
            </Box>
          }
          variant={"error"}
          autoHide={false}
          handleClose={this.closeErrorDialog}
          title="Validation Failure"
        />

        <Modal backdrop="static" show={this.props.Show} onHide={this.props.handleClose} enforceFocus={false}>
          <Modal.Header closeButton>
            <Modal.Title>
              <img
                src={logo}
                height="40pt"
                width="40pt"
                alt={Constants.COMPANY_SITE}
              />
              &nbsp;&nbsp;
              {this.props.editOperation
                ? "Edit Exchange Rate"
                : "Add New Exchange Rate"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <center>
              <table style={{ width: "100%" }}>
                <tbody>
                  {this.props.editOperation && (
                    <tr>
                      <td>
                        <Form.Label>Exchangerate Id</Form.Label>
                      </td>
                      <td>
                        <Form.Label>{this.props.sourceData.id}</Form.Label>
                      </td>
                    </tr>
                  )}
                  {this.props.editOperation && (
                    <tr>
                      <td>&nbsp;</td>
                    </tr>
                  )}
                  <tr>
                    <td>
                      <Form.Label>Exchange date</Form.Label>
                    </td>
                    {this.props.editOperation ? (
                      <td>
                        <Form.Label>
                          {Utility.GetFormatedDisplayDate(
                            this.state.newexchangedate
                          )}
                        </Form.Label>
                      </td>
                    ) : (
                      <td>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            ampm={true}
                            renderInput={(props) => (
                              <TextField
                                fullWidth
                                size="small"
                                {...props}
                                inputProps={{
                                  ...props.inputProps,
                                  readOnly: true,
                                }}
                              />
                            )}
                            error={false}
                            value={this.state.newexchangedate}
                            inputFormat="DD/MM/YYYY"
                            onChange={(dt) => {
                              // Get the current time
                              const now = dayjs();

                              // Set startOfMonth to the first day of the selected month, but with the current system time
                              const newExchangeRate = dayjs(this.state.newexchangedate)
                                .hour(now.hour())
                                .minute(now.minute())
                                .second(now.second())
                                .millisecond(now.millisecond())
                                .toDate();

                              this.setState({
                                newexchangedate: newExchangeRate,
                                showValidationMessage: false,
                              });
                              this.validateExchangedatePresent(newExchangeRate, true);
                            }}
                            maxDate={new Date()}
                          />
                        </LocalizationProvider>
                      </td>
                    )}
                  </tr>
                  <tr>
                    <td></td>
                    <td>
                      {this.state.validateExchangedatePresentSpinner ? (
                        <CircularProgress size="1rem" />
                      ) : !this.state.showValidationMessage ? (
                        <Box>&nbsp;</Box>
                      ) : this.state.exchangedateAvailable ? (
                        <font color="green">Exchange date available</font>
                      ) : (
                        <font color="red">Exchange date not available</font>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>
                        Rate <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Rate (required)"
                        placeholder="Enter Rate"
                        value={this.state.newrate}
                        onChange={(e) =>
                          this.setState({
                            newrate: e.target.value,
                            rateValidationError: Utility.CheckisNumberGreaterThanZero(
                              e.target.value
                            )
                              ? ""
                              : "Rate should be a Valid number greater than 0",
                          })
                        }
                        helperText={this.state.rateValidationError}
                        error={this.state.rateValidationError.length > 0}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Description</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Description"
                        placeholder="Enter Description"
                        value={this.state.newdescription}
                        onChange={(e) =>
                          this.setState({ newdescription: e.target.value })
                        }
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </center>
          </Modal.Body>
          <Modal.Footer>
            <LoadingButton
              loading={this.props.loading}
              loadingPosition="start"
              startIcon={<SaveIcon />}
              variant="contained"
              onClick={() => this.handleSave()}
              disabled={this.buttonDisable()}
              sx={{ mr: 1 }}
            >
              Save
            </LoadingButton>
            <Button
              variant="contained"
              color="error"
              onClick={this.props.handleClose}
              disabled={this.props.loading}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Box>
    );
  }
}
